import { render, staticRenderFns } from "./EditTopic.vue?vue&type=template&id=dab6dd20&"
import script from "./EditTopic.vue?vue&type=script&lang=js&"
export * from "./EditTopic.vue?vue&type=script&lang=js&"
import style0 from "./EditTopic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports